/* eslint-disable @typescript-eslint/no-explicit-any */
import { api_service } from '../api/api-service';
import { api_urls } from '../api/api-urls';
import { BrandDetails } from '../store/reducers/brandSlice';

export interface BrandApiResponse {
    statusCode: number;
    data?: BrandDetails;
    message?: string;
}

/**
 * Get brand configuration details
 * @param showLoader - Whether to show loading indicator (default: false)
 * @returns Promise with brand configuration response
 */
export const getBrandDetails = async (showLoader: boolean = false): Promise<BrandApiResponse> => {
    try {
        const response: any = await api_service.get({
            endPoint: api_urls.getConigDetails,
            showLoader,
        });
        const responseData = response?.data || response;
        return responseData;
    } catch (error: any) {
        console.error('Error fetching brand details:', error);
        throw error;
    }
};
